import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { useAuth } from "../../auth";
import { useMetrics } from "../../metrics.ts";
import Button from "../button/Button.tsx";
import { ButtonSize, ButtonVariant } from "../button/Button.types.ts";

const Logout = () => {
  const { t } = useTranslation();
  const { isAuthenticated, logout } = useAuth();
  const { trackAction } = useMetrics();
  const { pathname } = useLocation();

  const handleLogout = () => {
    trackAction.click({
      screenName: pathname,
      componentName: "button Logout",
    });

    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return isAuthenticated ? (
    <div className="w[100]">
      <Button
        onClick={handleLogout}
        text={t("logout.title")}
        variant={ButtonVariant.GHOST}
        size={ButtonSize.SMALL}
      />
    </div>
  ) : null;
};

export { Logout };
